import BaseModel from './BaseModel';
export default class Banner extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.filename = data.filename || this.translate.fileName || this.translate.filename || undefined;
        this.imageId = data.imageId || undefined;
        this.imageView = data.imageView || this.translate.imageView || undefined;
        this.isEnabled = data.isEnabled !== undefined ? data.isEnabled : true;
        this.order = data.order || undefined;
        this.type = data.type || undefined;
        this.url = data.url || this.translate.url || undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            filename: this.filename,
            imageId: this.imageId,
            // imageView: this.imageView,
            isEnabled: this.isEnabled,
            order: !!this.order ? Number(this.order) : undefined,
            type: this.type,
            url: this.url,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                bannerId: this.translate.bannerId || this.id,
                name: this.name,
                fileName: this.filename,
                url: this.url,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}